// VALIDAR e REVERTER de Aulas Dadas usam a MESMA permissao funcional --
// aulas_dadas -> validar (usePermissoes().podeValidar('aulas_dadas')) --
// nunca uma checagem de perfil (ADMIN/RH). O bypass de ADMIN e' resolvido
// de forma centralizada dentro do proprio usePermissoes (permissoes.is_admin),
// nao aqui. Backend ja exige require_permission("aulas_dadas", "validar")
// em /validar e /reverter (ver backend/app/routes/aula_dada.py).
const possuiPermissaoValidacaoAulas = (temPermissaoValidarAulas) =>
  Boolean(temPermissaoValidarAulas);

export const podeExibirBotaoValidar = (record, temPermissaoValidarAulas) =>
  possuiPermissaoValidacaoAulas(temPermissaoValidarAulas) && record?.status === 'PENDENTE';

export const podeExibirBotaoReverter = (record, temPermissaoValidarAulas) =>
  possuiPermissaoValidacaoAulas(temPermissaoValidarAulas) && record?.status !== 'PENDENTE';
